import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const StormIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 117 117" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M29.25 58.5008H87.75C91.6288 58.5008 95.3487 56.9599 98.0914 54.2172C100.834 51.4745 102.375 47.7546 102.375 43.8758C102.375 39.997 100.834 36.2771 98.0914 33.5343C95.3487 30.7916 91.6288 29.2508 87.75 29.2508C84.63 29.2508 82.0267 27.0034 80.7495 24.1564C78.8281 19.862 75.7049 16.2153 71.7569 13.6566C67.8088 11.0979 63.2047 9.73633 58.5 9.73633C53.7953 9.73633 49.1912 11.0979 45.2431 13.6566C41.2951 16.2153 38.1719 19.862 36.2505 24.1564C34.9732 27.0034 32.37 29.2508 29.25 29.2508C25.3712 29.2508 21.6513 30.7916 18.9086 33.5343C16.1658 36.2771 14.625 39.997 14.625 43.8758C14.625 47.7546 16.1658 51.4745 18.9086 54.2172C21.6513 56.9599 25.3712 58.5008 29.25 58.5008Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M49.8956 68.25L47.6433 72.0818C43.8067 78.6045 41.8908 81.8659 43.29 84.318C44.694 86.775 48.4818 86.775 56.0625 86.775C57.213 86.775 57.7882 86.775 58.1441 87.1309C58.5 87.4867 58.5 88.062 58.5 89.2125V98.2995C58.5 101.907 58.5 103.706 59.397 103.954C60.2988 104.198 61.2105 102.638 63.0386 99.5329L69.3566 88.7933C73.1932 82.2705 75.1091 79.0091 73.71 76.557C72.306 74.1 68.5181 74.1 60.9375 74.1C59.787 74.1 59.2117 74.1 58.8558 73.7441C58.5 73.3882 58.5 72.813 58.5 71.6625V68.25H49.8956Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default StormIcon;

StormIcon.propTypes = customIconsPropTypes;
